import { render, staticRenderFns } from "./MinesSidebar.vue?vue&type=template&id=f552b288&"
import script from "./MinesSidebar.vue?vue&type=script&lang=js&"
export * from "./MinesSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports